module.exports = __webpack_public_path__ + "static/social_ads-4ce3352b3e04999f714797ee753dfd92.jpg";